export interface ServiceModel {
  serviceId: number;
  serviceName: string;
}
